import React, { useState, useCallback } from 'react'
import Cropper from 'react-easy-crop'
import getCroppedImg from '../utils/crop'
import Styles from './styles/EasyCrop.module.css'
import ButtonGroup from '@mui/material/ButtonGroup';
import Slider from '@mui/material/Slider';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

export default function EasyCrop(props) {

    const MIN_ZOOM = 1
    const MAX_ZOOM = 3
    const STEP_ZOOM = 0.01

    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels)
    }, [])

    const convertToWebp = useCallback(async (initialBlob) => {
        return new Promise((resolve, reject) => {

            const image = new Image();
            image.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = image.naturalWidth;
                canvas.height = image.naturalHeight;
                canvas.getContext('2d').drawImage(image, 0, 0);

                canvas.toBlob((blob) => {
                    resolve(URL.createObjectURL(blob));
                }, 'image/webp', props.quality);
            }

            image.src = initialBlob;
        })
    }, [props.quality])

    const saveCroppedImg = useCallback(async () => {
        try {
            const croppedImage = await getCroppedImg(
                props.loadedImg,
                croppedAreaPixels
            )
            props.setLoadedImg(null)
            const newImage = await convertToWebp(croppedImage)
            props.setImage(newImage)

        } catch (e) {
            alert('Hubo un problema al guardar la imagen, intenta mas tarde')
        }
    }, [croppedAreaPixels, convertToWebp])

    return (
        <Stack
            justifyContent="center"
            alignItems="center"
            className={Styles.container}
        >
            <Typography variant="h4" gutterBottom>
                Recortar imagen
            </Typography>
            <div className={Styles.cropContainer}>
                <Cropper
                    image={props.loadedImg}
                    crop={crop}
                    zoom={zoom}
                    aspect={props.aspectRatio}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                />
            </div>
            <div className={Styles.controls}>
                <Stack spacing={2} direction="row" sx={{ mb: 1, width: '100%' }} alignItems="center">
                    <RemoveIcon color='info' onClick={zoom > MIN_ZOOM ? setZoom.bind(this, prev => prev - STEP_ZOOM) : null} sx={{ cursor: 'pointer' }} />
                    <Slider
                        value={zoom}
                        min={MIN_ZOOM}
                        max={MAX_ZOOM}
                        step={STEP_ZOOM}
                        aria-labelledby="Zoom"
                        onChange={(e, zoom) => setZoom(zoom)}
                    />
                    <AddIcon color='info' onClick={zoom < MAX_ZOOM ? setZoom.bind(this, prev => prev + STEP_ZOOM) : null} sx={{ cursor: 'pointer' }} />
                </Stack>

                <ButtonGroup variant="contained" aria-label="outlined primary button group"
                    size='large'
                    sx={{ width: 'fit-content' }}
                >
                    <Button
                        onClick={() => props.setLoadedImg(null)}
                        variant='contained'
                        color='error'
                    >
                        Descartar
                    </Button>
                    <Button onClick={saveCroppedImg} variant='contained'>
                        Confirmar
                    </Button>
                </ButtonGroup>
            </div>
        </Stack>
    )
}